import { globalNocowanieStyles } from './global-nocowanie.styles';

export const globalCss = {
    '@font-face': {
        fontFamily: '"proxima-nova-fallback"',
        src: 'local("Arial")',
        sizeAdjust: '97%',
        ascentOverride: '90%',
        descentOverride: '22%',
        lineGapOverride: '0%',
    },
    html: {
        fontFamily: '"proxima-nova", "proxima-nova-fallback", Arial, sans-serif',
        color: '{colors.bodyText}',
        colorPalette: 'secondary',
    },
    ...globalNocowanieStyles,
};
